/** InsCoder WANG.J 2026-07-21 B + Community three-reasons accordion behavior. **/
if (!customElements.get('community-three-reasons')) {
  customElements.define(
    'community-three-reasons',
    class CommunityThreeReasons extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.querySelectorAll('details').forEach((details) => {
          details.addEventListener('toggle', () => {
            if (!details.open) return;
            this.querySelectorAll('details[open]').forEach((item) => {
              if (item !== details) item.removeAttribute('open');
            });
          });
        });
      }
    }
  );
}
/** InsCoder WANG.J 2026-07-21 E + Community three-reasons accordion behavior. **/
